export default __webpack_public_path__ + "static/media/twitter.ae242d0b.svg";